import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  ruhsat_no: string;
  make: string;
  model: string;
  driver_identification: string;
  leaseservice_distance: string;
  leaseservice_duration: string;
  cc_lastknowndist: string;
};

export default async function getFleetCarRepository(): Promise<ServiceResponse[]> {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/vehicle`);
  return res.data;
}
